export default [
    {
        value: "",
        pattern: "^.{2,}$",
        placeholder: "Voornaam",
        question: "Wat is je voornaam?",
        name: "first_name",
        type: "text",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: "^.{2,}$",
        placeholder: "Achternaam",
        question: "Wat is je achternaam?",
        name: "last_name",
        type: "text",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Wat is je geboortedatum?",
        name: "date_of_birth",
        type: "date",
        placeholder: "dd-mm-yyyy",
        explanation: "Let op: solliciteren is mogelijk vanaf 16 jaar",
        attributes: {
            max: new Date(new Date().getFullYear() + 99, new Date().getMonth(), new Date().getDate())
                .toISOString()
                .split("T")[0],
            min: new Date(new Date().getFullYear() - 99, new Date().getMonth(), new Date().getDate())
                .toISOString()
                .split("T")[0],
        },
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: null,
        placeholder: "E-mailadres",
        question: "Wat is je e-mailadres?",
        name: "email",
        type: "email",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: "^[0-9]{6,}$",
        placeholder: "Telefoonnummer",
        question: "Wat is je telefoonnummer?",
        name: "tel",
        type: "tel",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Wat is je postcode?",
        pattern: "^(?:[1-9]\\d{3}\\s?[A-Z]{2}|[1-9]\\d{3})$",
        explanation:
            "Vul je postcode in het juiste formaat in. Dit betekent voor Nederland dat je zowel de vier cijfers als de twee letters moet opgeven, bijvoorbeeld: 1234AB en voor België alleen 1234.",
        name: "zipcode",
        type: "text",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: "^.{2,}$",
        question: "Welke functie past bij jou?",
        name: "animation_type_fitted",
        type: "multiselect",
        explanation: "Kies een of meerdere functies",
        options: [
            "Allround Topper",
            "Sport Topper",
            "Theater Topper ",
            "Teenage Topper",
            "TOP Leider",
            "Stage Topper",
            "Duo Topper",
            "Duitse Topper",
        ],
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: null,
        question: "Hoe ben je bij ons terecht gekomen?",
        name: "reference",
        type: "select",
        options: [
            "Google",
            "Instagram",
            "TikTok",
            "Yobbers",
            "Via school",
            "Via een (oud) entertainer",
            "Via de camping",
        ],
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: "^.{2,}$",
        placeholder: "",
        question: "Waar woon je?",
        name: "housing_situation",
        type: "text",
        step: 2,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: "^.{2,}$",
        question: "Welke opleiding of welk werk doe je?",
        name: "education",
        type: "text",
        step: 2,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Hoe goed spreek je Nederlands?",
        name: "dutch_education",
        type: "select",
        options: ["Slecht", "Matig", "Goed", "Moedertaal"],
        step: 2,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Hoe goed spreek je Engels?",
        name: "english_education",
        type: "select",
        options: ["Slecht", "Matig", "Goed", "Moedertaal"],
        step: 2,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Hoe goed spreek je Duits?",
        name: "german_education",
        type: "select",
        options: ["Slecht", "Matig", "Goed", "Moedertaal"],
        step: 2,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: "^.{2,}$",
        question: "Heb je ervaring met animatiewerk?",
        name: "experience",
        type: "text",
        step: 2,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: "^.{2,}$",
        question: "Hoe zouden jouw vrienden je omschrijven?",
        name: "friends_description",
        type: "textarea",
        step: 2,
        valid: false,
        required: true,
    },
    {
        value: "",
        pattern: null,
        question: "Indien je een superheld kon zijn, wie zou je kiezen?",
        name: "superhero_answer",
        type: "textarea",
        step: 2,
        valid: false,
        required: false,
    },
    {
        value: "",
        pattern: null,
        question: "Waarom ben jij de entertainer die wij zoeken?",
        name: "motivation",
        type: "textarea",
        step: 2,
        valid: false,
        required: false,
    },
    {
        value: "",
        pattern: null,
        question: "Upload hier je meest entertainer waardige foto!",
        name: "personal_photo",
        type: "file",
        step: 2,
        valid: false,
        required: false,
    },
];
